import React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    EditButton,
    TopToolbar,
} from 'react-admin';
import { makeStyles } from '@material-ui/core';

import { ViewTitle } from '../ui';
import { UserContextTitle } from './UserContextTitle';
export const UserContextShow = props => {
    const classes = useStyles(props);

    return (
        <>
            <ViewTitle />
            <Show
                {...props}
                title={<UserContextTitle {...props} />}
                actions={null}
            >
                <SimpleShowLayout className={classes.root}>
                    <TextField
                        className={classes.field}
                        source="userDetails.username"
                    />
                    <TextField
                        className={classes.field}
                        source="userDetails.email"
                    />
                    <TextField
                        className={classes.field}
                        source="userDetails.firstName"
                    />
                    <TextField
                        className={classes.field}
                        source="userDetails.lastName"
                    />
                    {/* <UserContextSubtitle /> */}
                    {/* <TextField
                        className={classes.field}
                        source="userDetails.password"
                        type="password"
                    /> */}
                    <br></br>
                    <EditButton />
                </SimpleShowLayout>
            </Show>
        </>
    );
};

const useStyles = makeStyles(
    theme => ({
        root: {
            padding: `${theme.spacing(4)}px !important`,
        },
        field: {
            width: 456,
        },
    }),
    {
        name: 'Layer7UserContextShow',
    }
);
